import {
	Http
}
from '../utils/http.js'
import {
	cache
} from '@/utils/cache.js';
import {
	add,
	adds
} from '../utils/cal'

class Cart extends Http {
	constructor() {
		super();
		this._storageKeyName = `${this._storageKey}cart`;
	}

	getStoreData(callback) {
		var params = {
			url: '',
			sCallback: function (res) {
				callback && callback(res);
			}
		}
		this.request(params);
	}

	/**
	 * 从本地缓存获取购物车数据
	 * param:
	 * flag:是否统计选中的购物车的商品数量,true 只统计选中的
	 */
	getCartDataFromLocal(flag) {
		var data = cache.get(this._storageKeyName);
		if (!data) {
			data = [];
		}
		if (flag) {
			var newData = [];
			for (var i = 0; i < data.length; i++) {
				if (data[i].selectStatus) {
					newData.push(data[i]);
				}
			}
			data = newData;
		}
		return data;
	}

	getCartDataFromServer(sign, original = 0) {
		return this.request({
			method: 'post',
			url: '/cart/detail',
			data: {
				sign,
				original
			}
		})
	}

	/**
	 * 检测 商品 是否存在储存购物车数组
	 * param:
	 * id:商品id,
	 * spec_key：商品规格
	 * return: index购物车索引，以及商品数量
	 */
	isHasThatOne(id, spec_key, arr) {
		// 不存在
		var res = {
			index: -1,
			count: 0
		}
		arr = arr || this.getCartDataFromLocal();
		for (var i = 0; i < arr.length; i++) {
			var item = arr[i];
			item.spec_key = item.spec_key || '';
			if (id == item.id && spec_key == item.spec_key) {
				res.index = i;
				res.count = item.count;
				break;
			}
		}
		return res;
	}

	/**
	 * 添加购物车
	 * 购物车里面有商品则更新商品的数量
	 * 购物车里面没有该商品则新增加信息
	 * @params:
	 * item-{obj} 商品对象
	 * count - {int }商品数目
	 */
	add(item, count) {
		var cartArr = this.getCartDataFromLocal(),
			isHasItem = this.isHasThatOne(item.id, item.spec_key, cartArr);
		if (isHasItem.index == -1) {
			item.count = count;
			item.selectStatus = true;

			cartArr.push(item);
		} else {
			cartArr[isHasItem.index].count += count;
		}
		// wx.setStorageSync(this._storageKeyName, cartArr)
		this.execSetStorageSync(cartArr)
	}

	// 增加
	addCount(id, spec_key) {
		this._changProductItemCount(id, 1, spec_key);
	}

	// 减少
	cutCount(id, spec_key) {
		this._changProductItemCount(id, -1, spec_key);
	}
	// 保存缓存
	execSetStorageSync(data) {
		cache.set(this._storageKeyName, data);
	}
	cache(data) {
		this.execSetStorageSync(data)
	}

	// 改变商品数量 count为正增加 负则减少
	_changProductItemCount(id, count, spec_key) {
		var cartArr = this.getCartDataFromLocal(),
			isHasItem = this.isHasThatOne(id, spec_key, cartArr);
		if (isHasItem.index != -1) {
			var res = cartArr[isHasItem.index].count + count;
			if (res == 0) {
				cartArr.splice(isHasItem.index, 1);
			} else {
				cartArr[isHasItem.index].count += count;
			}
			this.execSetStorageSync(cartArr)
		}
	}

	// 删除购物车里面某商品
	delete(ids, spec_keys) {
		if (!(ids instanceof Array)) {
			ids = [ids];
		}
		if (!(spec_keys instanceof Array)) {
			spec_keys = [spec_keys];
		}
		var cartArr = this.getCartDataFromLocal();

		for (var i = 0; i < ids.length; i++) {
			var isHasItem = this.isHasThatOne(ids[i], spec_keys[i], cartArr);
			var index = isHasItem.index;

			if (index != -1) {
				cartArr.splice(index, 1);
			}
		}

		this.execSetStorageSync(cartArr)
	}

	/**
	 * param:
	 * flag:是否统计选中的购物车的商品数量,true 只统计选中的
	 */
	getCartItemCount(flag) {
		var data = cache.get(this._storageKeyName),
			count = 0;
		if (data && data.length > 0)
			for (var i = 0; i < data.length; i++) {
				if (flag) {
					if (data[i].selectStatus)
						count = adds(count, data[i].count);
				} else {
					count = adds(count, data[i].count);
				}
			}
		return count;
	}

	scanOk(sign) {
		return this.request({
			method: 'post',
			url: '/cart/scanOk',
			data: {
				sign
			}
		})
	}
}

export {
	Cart
};
